// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"7bef3dfc","408":"62393737","732":"f6424576","977":"d5b34947"}[chunkId] + ".chunk.js";
};